module.exports = __webpack_public_path__ + "static/media/custom_bg.b00fdde0.png";